<template>
<div class="card">
    <loading :active.sync="retrieveListLoading" 
        :can-cancel="true"
        :is-full-page="false">
    </loading>
    <div class="card-header d-flex align-items-center justify-content-between user-title">
        <h3>Kakao User List</h3> 
        <h5>Bot ID : {{ kakaoBotId }}</h5>         
    </div>

    <div class="card-body">
        <div class="d-flex mb-3">
            <button type="button" class="btn btn-success flex-grow-0" v-on:click="showKakaoUserPopup()">Kakao User 생성</button>
        </div>
        <table class="table table-bordered table-striped table-hover">
            <thead class="">
                <tr class="text-center device-table-header">
                    <!-- <th>Kakao User ID</th> -->
                    <th>Email</th>
                    <th>Status</th>
                    <th>Detail</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="kakaoUser in kakaoUserList">
                    <!-- <td>{{ kakaoUser.kakaoUserId }}</td> -->
                    <td>{{ kakaoUser.email }}</td>
                    <td>{{ statusMap[kakaoUser.status] }}</td>
                    <td class="text-center">
                        <button type="button" class="btn btn-blue" @click="showKakaoUserPopup(kakaoUser)">Detail</button>
                    </td>
                </tr>
                <tr v-show="kakaoUserList.length == 0">
                    <td class="text-center" colspan="4">결과가 없습니다.</td>
                </tr>
            </tbody>
        </table>
        <div class="text-center">
            <button class="btn btn-view-more" v-bind:style="{width:'40%'}" v-on:click="seeMore()" :disabled="kakaoUserList.length == total">더보기 ({{ kakaoUserList.length }} / {{ total }})</button>
        </div>
    </div>
    <!--card-body-->

    <!--Detail modal start-->
    <b-modal size="lg" ref="requestModal" header-class="detail-header" title="Kakao User Information" ok-only ok-variant="secondary" ok-title="Close"> <!-- size = xl, lg, sm -->
        <loading :active.sync="requestLoading" 
            :can-cancel="false" 
            :is-full-page="false"></loading>
        <table class="table table-striped table-bordered table-hover shadow-sm mt-2">
            <tbody>
                <tr>
                    <td>Kakao Bot ID *</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input class="form-control" placeholder="Kakao Bot ID" name="kakaoBotId" v-model= "kakaoUser.kakaoBotId" v-validate="'required'" disabled>         
                            <div class="alert-danger" v-if="submitted && errors.has('kakaoBotId')">{{ errors.first('kakaoBotId') }}</div>
                        </div>
                    </td>
                </tr>
                <tr v-if="existentFlag">
                    <td>Kakao User ID *</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input class="form-control" maxlength="256" placeholder="Kakao User ID" name="kakaoUserId" v-model="kakaoUser.kakaoUserId" v-validate="'required'" :disabled="existentFlag"/>
                            <div class="alert-danger" v-if="submitted && errors.has('kakaoUserId')">{{ errors.first('kakaoUserId') }}</div>
                        </div>
                    </td>
                </tr>
                <tr v-if="existentFlag">
                    <td>Status *</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <b-form-select v-model="kakaoUser.status" :options="statusOptions" size="" v-validate="'required'" name="status">
                            </b-form-select>
                            <div class="alert-danger" v-if="submitted && errors.has('status')">{{ errors.first('status') }}</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>Email (1)</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input type="email" class="form-control" placeholder="gildong.hong@kr.ey.com" name="email" v-model="kakaoUser.email" v-validate="'required'"/>
                            <div class="alert-danger" v-if="submitted && errors.has('email')">{{ errors.first('email') }}</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>Email (2)</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input type="email" class="form-control" placeholder="gildong.hong@kr.ey.com" name="subEmail" v-model="kakaoUser.subEmail" v-validate="'required'"/>
                            <div class="alert-danger" v-if="submitted && errors.has('subEmail')">{{ errors.first('subEmail') }}</div>
                        </div>
                    </td>
                </tr>
                <tr v-if="existentFlag && kakaoUser.status == 'registering'" >
                    <td>Passcode</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input class="form-control" placeholder="" name="passcode" v-model="kakaoUser.passcode" v-validate="''" disabled/>
                            <div class="alert-danger" v-if="submitted && errors.has('passcode')">{{ errors.first('passcode') }}</div>
                        </div>
                    </td>
                </tr>           
            </tbody>
        </table>
        <div class="text-center pb-2" style="display: inline-block; float: right;" >
            <button type="button" class="btn btn-success" v-on:click="requestKakaoUser()">{{ existentFlag ? 'Update' : 'Submit' }}</button>
            <button v-show="!existentFlag" type="button" class="btn btn-danger" style="margin-left: 10px;" v-on:click="resetRequestForm()">Reset</button>
            <button v-show="existentFlag" type="button" class="btn btn-danger" style="margin-left: 10px;" v-on:click="deleteKakaoUser()">Delete</button>
        </div>
    </b-modal>
    <!--Detail modal end -->

    <!--Message Modal-->
    <b-modal id="messageModal" header-class="fail-header" title="Message" ok-only ok-variant="secondary" ok-title="Close">
        <p class="my-4 text-center">{{ msgContent }}</p>
    </b-modal>   

</div><!--card-->
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'Kakao',
    data() {
        return {        
            kakaoUserList: [],  // retrieveKakaoUserList의 결과
            total: 0,  // 이 화면의 검색 조건에 맞는 WorkMan에 있는 KakaoUser 총 개수
            limit: 0,
            offset: 0,
            PAGE_LIMIT : 5,

            existentFlag: false,  // 이미 있는 Kakao User 여부 (있으면 수정/삭제가 가능, 없으면 신규 요청이 가능)
            // 신청(updateKakaoUser) 팝업에서 사용
            kakaoBotId: '',
            kakaoUser: {},
            statusOptions: [
                { value: 'registering', text: '신청중' },
                { value: 'available', text: '승인완료' },
                { value: 'inactive', text: '일시중지' }
            ],
            statusMap: {
                'registering' : '신청중',
                'available' : '승인완료',
                'inactive' : '일시중지',
            },

            submitted: false,  // true가 되면 validate 를 진행함
            retrieveListLoading: false,  // Kakao User 리스트를 보여주는 곳의 로딩바
            requestLoading: false,  // Kakao User 신청 폼에서 보여주는 로딩바

            msgStatus: '',  // alert popup 의 status 인데 사용하진 않고, 아래 content는 보여줌
            msgContent: ''
        }
    },
    components: {
        Loading
    },
    computed: {
    },
    methods: {
        showMessage(status, message) {
            this.msgStatus = status;
            this.msgContent = message;
            
            this.$bvModal.show('messageModal');
        },
        showKakaoUserPopup(kakaoUser) {
            this.existentFlag = false;
            this.resetRequestForm();

            if (kakaoUser != null) {
                this.requestLoading = true;

                var params = {
                    'kakaoBotId': kakaoUser.kakaoBotId.trim(),
                    'kakaoUserId': kakaoUser.kakaoUserId.trim()
                };

                axios.get('peon/retrieveKakaoUser', {
                    params: params,
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': accessToken()
                    }
                }).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                    if(response.data.body == null) {
                        this.showMessage(-1, "wrong information");
                        return;
                    }

                    this.kakaoUser = response.data.body;          
                    this.existentFlag = true;
                }).catch(error => {
                    if (error.status != 401) {
                        this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                    }
                }).finally(() => {
                    this.requestLoading = false;
                });
            } else {
                this.resetRequestForm();
            }

            this.$refs['requestModal'].show();
        },
        resetRequestForm() {
            this.kakaoUser = {};
            this.kakaoUser.kakaoBotId = this.kakaoBotId;
            this.kakaoUser.status = 'registering';
        },
        seeMore() {
            if (this.kakaoUserList && this.kakaoUserList.length > 0) {
                this.offset = this.offset + this.limit;
            }

            this.retrieveKakaoUserList();
        },
        reloadRetrieveKakaoUserList() {
            // 재조회를 위한 값
            this.offset = 0;
            this.limit = (this.kakaoUserList.length % this.PAGE_LIMIT === 0 ? parseInt(this.kakaoUserList.length / this.PAGE_LIMIT) : parseInt(this.kakaoUserList.length / this.PAGE_LIMIT) + 1) * this.PAGE_LIMIT;
            this.kakaoUserList = [];

            this.retrieveKakaoUserList();

            // 원래값
            this.offset = this.limit - this.PAGE_LIMIT;
            this.limit = this.PAGE_LIMIT;
        },
        retrieveKakaoUserList() {            
            this.retrieveListLoading = true;
           
            var params = {
                'offset': this.offset,
                'limit': this.limit
            };

            axios.post('peon/retrieveKakaoUserList', params, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                response.data.body.list.forEach((item, index, array) => {
                    this.kakaoUserList.push(item);
                });

                this.total = response.data.body.total;
                this.kakaoBotId = response.data.body.kakaoBotId;
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.retrieveListLoading = false;
            });           
        },
        requestKakaoUser() {
            this.submitted = true;

            this.$validator.validate().then(valid => {
                if (valid) {
                    this.requestLoading = true;

                    var UPDATE_URL = 'upsertKakaoUser';

                    if (!this.existentFlag) {
                        this.kakaoUser.status = 'registering';
                        // UPDATE_URL = 'updateKakaoUser'
                    }

                    axios.post('peon/' + UPDATE_URL, this.kakaoUser, {
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': accessToken()
                        }
                    }).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                        this.submitted = false;

                        this.reloadRetrieveKakaoUserList();

                        this.$refs['requestModal'].hide();

                        this.showMessage(0, "사용자 " + (this.existentFlag ? "수정이" : "추가가") + " 완료되었습니다.");
                    }).catch(error => {
                        if (error.status != 401) {
                            this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                        }
                    }).finally(() => {
                        this.requestLoading = false;
                        this.submitted = false;
                    });
                }
            });
        },
        deleteKakaoUser() {
            this.requestLoading = true;
           
            var params = {
                'kakaoBotId': this.kakaoUser.kakaoBotId.trim(),
                'kakaoUserId': this.kakaoUser.kakaoUserId.trim()
            };

            axios.get('peon/deleteKakaoUser', {
                params: params,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                this.reloadRetrieveKakaoUserList();

                this.$refs['requestModal'].hide();

                this.showMessage(0, "사용자 삭제가 완료되었습니다.");
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.requestLoading = false;
            });
        }
    },
    created() {
        this.limit = this.PAGE_LIMIT;
        this.retrieveKakaoUserList();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
